import { gql } from '@apollo/client';

const createStartWork = gql`
  mutation createStartWork(
    $branch: String
    $time: Date
    $title: String
    $desc: String
    $contract: ContractInput
    $department: DepartmentInput
    $employee: EmployeeInput
    $bonos: Float
    $overtime: Float
    $deduction: Float
    $isWorking: Int
    $isAbsent: Int
    $isShift1: Int
    $isShift2: Int
    $isVacation: Boolean
    $userId: String
    $note: String
  ) {
    createStartWork(
      branch: $branch
      time: $time
      title: $title
      desc: $desc
      contract: $contract
      department: $department
      employee: $employee
      bonos: $bonos
      overtime: $overtime
      deduction: $deduction
      isWorking: $isWorking
      isAbsent: $isAbsent
      isShift1: $isShift1
      isShift2: $isShift2
      isVacation: $isVacation
      userId: $userId
      note: $note
    ) {
      ok
      message
      error
    }
  }
`;

export default createStartWork;
